//import { TransformComponent, TransformWrapper } from '@kokarn/react-zoom-pan-pinch';
import { useState } from 'react';

// import { Document, Page, pdfjs } from 'react-pdf';

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const pdfExtension = 'pdf';
const imageExtensions = ['png', 'jpg', 'jpeg'];

const ImgPDF = ({ className, url, extension }) => {
  const [pageNumber, setPageNumber] = useState(1);

  let containerClassName = '';
  if (className) {
    containerClassName = className;
  }

  /*  return (
    <TransformWrapper>
      {() => (
        <TransformComponent>
          {extension === pdfExtension && (
            <Document className={containerClassName} file={url} onLoadSuccess={() => setPageNumber(1)}>
              <Page pageNumber={pageNumber} />
            </Document>
          )}
          {imageExtensions.includes(extension) && <img className={containerClassName} src={url} alt='visualization' />}
        </TransformComponent>
      )}
    </TransformWrapper>
  ); */
  return 'PDF';
};

export default ImgPDF;
